import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileText = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.243 28 4 25.757 4 23V9C4 6.243 6.243 4 9 4H23C25.757 4 28 6.243 28 9V23C28 25.757 25.757 28 23 28ZM9 6C7.346 6 6 7.346 6 9V23C6 24.654 7.346 26 9 26H23C24.654 26 26 24.654 26 23V9C26 7.346 24.654 6 23 6H9Z" />
		<path d="M21 24H11C10.448 24 10 23.552 10 23C10 22.448 10.448 22 11 22H21C21.552 22 22 22.448 22 23C22 23.552 21.552 24 21 24Z" />
		<path d="M21.897 18.561C21.896 18.558 16.894 8.553 16.894 8.553C16.725 8.214 16.378 8 16 8C15.622 8 15.275 8.214 15.106 8.553C15.106 8.553 10.104 18.558 10.103 18.561C10.038 18.694 10 18.843 10 19C10 19.552 10.448 20 11 20C11.389 20 11.726 19.777 11.891 19.453C11.892 19.451 12.618 18 12.618 18H19.382C19.382 18 20.108 19.45 20.109 19.451C20.274 19.776 20.611 20 21.001 20C21.553 20 22.001 19.552 22.001 19C22.001 18.842 21.963 18.694 21.898 18.561H21.897ZM13.618 16L16 11.236L18.382 16H13.618V16Z" />
	</svg>
);

export default FileText;
